/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsVignetteBookingTemplateData } from '../../models/mail-params-vignette-booking-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendVignetteBookingMail$Params {
      body: MailParamsVignetteBookingTemplateData
}

export function sendVignetteBookingMail(http: HttpClient, rootUrl: string, params: SendVignetteBookingMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendVignetteBookingMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendVignetteBookingMail.PATH = '/sendMail/vignette-booking';
